import { Group, Stack } from '@mantine/core';
import XSafeTextInfo from './x-safe-text-info.component';

interface TextInfoProps {
  label: JSX.Element | string | number | null | undefined;
  value?: JSX.Element | string | number | null | undefined;
  orientation?: 'vertical' | 'horizontal';
}

const XTextStackInfo = (props: TextInfoProps) => {
  const { label, value, orientation } = props;

  return orientation === 'horizontal' ? (
    <Group spacing='xs'>
      <XSafeTextInfo data={label} size='sm' weight={600} />
      <XSafeTextInfo data={value} size='sm' />
    </Group>
  ) : (
    <Stack spacing='xs'>
      <XSafeTextInfo data={label} size='sm' weight={600} />
      <XSafeTextInfo data={value} size='sm' />
    </Stack>
  );
};

export default XTextStackInfo;
